import { isSubscriptionOrderType } from "~/shared/utils/sharedUtils";

import {
  EXPERIMENT_ONE_TIME_PURCHASE_DISCLOSURE,
  VARIANT_TEST,
} from "../experimentKeys";
import { useExperimentVariant } from "../useExperimentVariant";

// useOneTimePurchaseDisclosure decides whether to render the purchase disclosure panel
// above the Confirm button.
//
// ONE-TIME ORDERS ONLY. A subscription is an automatic-renewal offer, and ROSCA and the
// state automatic-renewal laws require its recurring-billing and cancellation terms to
// be disclosed before the charge -- so a subscription checkout is never eligible and
// always shows the panel. That gate is here, in code, rather than as a PostHog release
// condition: PostHog cannot see what is in the cart, and a person property would be
// stale by the time it mattered.
//
// Returns { ready, hidden }. Callers must not render the payment step's disclosure
// area until `ready`, and must suppress the recorded terms version when `hidden` --
// recording an acceptance for a panel the customer never saw would fabricate the exact
// evidence the acceptance record exists to provide.
// consultationType is passed through to the exposure event so results can be read per
// visit type. It matters here specifically: an initial patient is making a first-time
// purchase decision, while a follow-up has bought this before and has different
// reasons to hesitate. Read in aggregate, one can mask or invent an effect in the
// other.
export function useOneTimePurchaseDisclosure(orderType, consultationType) {
  const eligible = Boolean(orderType) && !isSubscriptionOrderType(orderType);

  const { ready, variant } = useExperimentVariant(
    EXPERIMENT_ONE_TIME_PURCHASE_DISCLOSURE,
    {
      eligible,
      exposureProperties: consultationType
        ? { consultation_type: consultationType }
        : undefined,
    },
  );

  return { ready, hidden: eligible && variant === VARIANT_TEST };
}
